import {useCallback} from 'react';
import {unwrapResult} from '@reduxjs/toolkit';
import {useAppDispatch, useAppSelector} from '../hooks';
import * as actions from './actions';
import * as selectors from './selectors';

export const usePreferencesFacade = () => {
    const dispatch = useAppDispatch();

    const marketingEmailStatus = useAppSelector(selectors.getMarketingEmailStatus);
    const pushNotificationsStatus = useAppSelector(selectors.getPushNotificationsStatus);
    const isFetching = useAppSelector(selectors.getIsFetching);
    const isSaving = useAppSelector(selectors.getIsSaving);
    const errorMessage = useAppSelector(selectors.getErrorMessage);

    const fetchPreferences = useCallback((customerId: number) => {
        return dispatch(actions.getCommunicationPreferences(customerId)).then(unwrapResult);
    }, [dispatch]);

    const updatePreferences = useCallback((customerId: number, marketing_email_status: number, push_notifications_status?: number, marketing_email_reason?: string) => {
        return dispatch(actions.updateCommunicationPreferences({
            customerId,
            data: { marketing_email_status, marketing_email_reason, push_notifications_status }
        })).then(unwrapResult);
    }, [dispatch]);

    const clearErrors = useCallback(() => {
        dispatch(actions.clearErrorsAction());
    }, [dispatch]);

    const clearAll = useCallback(() => {
        return dispatch(actions.clearAllAction()).then(unwrapResult);
    }, [dispatch]);

    return {
        marketingEmailStatus,
        pushNotificationsStatus,
        isFetching,
        isSaving,
        errorMessage,
        fetchPreferences,
        updatePreferences,
        clearErrors,
        clearAll,
    };
};
